<template>
  <div class="admin-users-detail">
    <ul class="admin-users-detail__header">
      <li class="menu-item">
        <router-link to="info" active-class="chosen-one">基本信息</router-link>
      </li>
      <li class="menu-item">
        <router-link to="vertify" active-class="chosen-one">认证信息</router-link>
      </li>
      <li class="menu-item">
        <router-link to="order" active-class="chosen-one">订单信息</router-link>
      </li>
      <li class="menu-item">
        <router-link to="package" active-class="chosen-one">套餐信息</router-link>
      </li>
      <li class="menu-item">
        <router-link to="charge" active-class="chosen-one">充值信息</router-link>
      </li>
    </ul>
    <div class="admin-users-detail__body">
      <router-view> </router-view>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.admin-users-detail {
  ul,
  li {
    list-style: none;
  }
  &__header {
    background-color: white;
    display: flex;
    align-items: center;
    padding: 25px 20px;
    border-radius: 4px;
    .menu-item {
      margin-right: 40px;
      width: 56px;
      height: 20px;
      font-size: 12px;
      line-height: 20px;
      a {
        text-decoration: none;
        color: #8998a0;
      }
      .chosen-one {
        color: #040b28;
        font-size: 14px;
        font-weight: bold;
      }
    }
  }
  &__body {
    margin-top: 16px;
  }
}
</style>
